/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_content_delivery_bucket": "alerus-client-portal-mfa",
    "aws_content_delivery_bucket_region": "us-east-2",
    "aws_content_delivery_url": "https://dhkxq5y7binoz.cloudfront.net",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_UXPU3WAVp",
    "aws_user_pools_web_client_id": "6sl2g2kqugg8r30a6m3t8o3t9r",
    "oauth": {
        "domain": "alerus-login-mfa-mfa.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:8080/,https://login-mfa.alerus.com/",
        "redirectSignOut": "http://localhost:8080/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_appsync_graphqlEndpoint": "https://xffycga6bvha3os5nnitace2ce.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-p4wdev5hvbbu7nnlzl5etpg2ny"
};


export default awsmobile;
